// Not following kebab case because it'll be used on FE to display error messages from translation files, on a cleaner way
export enum InterviewDateErrors {
  SameDate = 'sameDates',
  InterviewInThePast = 'interviewInThePast',
}
